module.exports = __webpack_public_path__ + "img/liushui (6).c06ba1bc.png";